import jwtDecode from "jwt-decode";
import IO from "socket.io-client";
import { getChatsAtendimento, getChatsFinalizados, getChatsGeral, getChatsPendente, getCountsChats, removeMsgEnviar, reorderChatsAtendimento, resetMensagensEnviar, setChatsAnalysis, setMensagensEnviar, setPushMensagemMeta, updateChatInfoField, updateChatList, updateMensagensEnviar, updateChatGrupoFromSocket, getChatsGrupos } from "src/redux/slices/chat";

import alertaSound from "src/assets/alerta.mp3";
import messageSound from "src/assets/message.mp3";
import chamadoSound from "src/assets/som-chamado.mp3";

// import Actions from "../constants/Actions";
import { setMetaMessages, setMessageWhatsapp, getMessagesMeta, addNewMessageCliente } from './redux/slices/chat'
import { setDefcon1, setUpdateAvailable, setLoadingQrcodeWhatsapp, setQrcode, setStateWhatsapp, setStatusQrcode } from 'src/redux/slices/global'
import { getIoInit, setAddRoomUnread, setOnlineUsers, setMessage, getListaStaffsWithoutIsGroup, setIsOnlineUsers } from 'src/redux/slices/staff';
import { store } from "./redux/store";
// import getRooms from "./getRooms";
import { notifyMe, notifyMeComentario, notifyMeStaff, notifyNewMessage, obterNumeroPorClienteId, soNumeros } from 'src/utils/functions';
import { getListaNotificacoes } from "src/redux/slices/notificacoes";
import { getRefreshComments, getListaColunas, getListaTickets } from "src/redux/slices/chamados";
import getActionClienteByClienteId from "src/actions/clientes/getActionClienteByClienteId";
import actionListaClientesCanais from "src/actions/clientes/actionListaClientesCanais";
import { promise as socketPromise } from './lib/socket.io-promise';
import Worker from "./actions/idb/workers/app.worker.worker?worker";
import { downloadMediaAndSaveCache } from "./helpers/cache.helper";
import { checkMsgToInsert } from "./utils/chats.utils";
import { getSessionStorageItem, setSessionStorageItem } from "./services/sessionStorage";

// Função utilitária para acessar o estado de forma segura
const getSafeState = (statePath) => {
  try {
    const state = store.getState();
    const path = statePath.split('.');
    let result = state;

    for (const key of path) {
      if (result && typeof result === 'object' && key in result) {
        result = result[key];
      } else {
        return null;
      }
    }

    return result;
  } catch (error) {
    console.error('Erro ao acessar estado:', error);
    return null;
  }
};

const initIO = token => (dispatch) => {
  const user = jwtDecode(token);

  const clienteData = localStorage.getItem('cliente_data');
  const clienteParse = JSON.parse(clienteData);
  const wbWorker = new Worker();

  let io = IO(`https://ws.zindi.com.br` + '/');
  io.request = socketPromise(io);

  ////// sistema antigo

  function playSoundNotification() {
    const soundNotification = localStorage.getItem('soundNotification');
    if (soundNotification === "true") {
      const audio = document.createElement('audio');
      audio.style.display = "none";
      audio.src = alertaSound;
      audio.autoplay = soundNotification;
      audio.onended = () => audio.remove();
      document.body.appendChild(audio);
    }

  }

  io.on('connect', () => {
    const currentToken = localStorage.getItem('token');
    if (currentToken) {
      io.emit('authenticate', { token: currentToken });
    } else {
      io.disconnect();
    }
  });

  io.on('authenticated', () => {
    dispatch(getIoInit(io));
  });

  io.on('unauthorized', (error) => {
    console.warn('WebSocket auth failed:', error?.message);
    localStorage.removeItem('token');
    window.location.href = '/login';
  });

  io.on('connect_error', (error) => {
    console.warn('WebSocket connection error:', error?.message);
  });

  // verificar se há chats pendentes, havendo, toca-se um sinal sonoro
  // setInterval(async () => {
  //   getActionListaChatsByStatus({ clienteId: user.clienteId, status: "Pendente", usuarioId: user.id, setorId: user.setorId }).then(res => {
  //     if (res.data.length > 0) {
  //       playSoundNotification();
  //       notifyMe2(res.data.length);
  //     }

  //   }).catch(err => console.log(err));

  // }, 180000);


  setInterval(async () => {
    const roomsWithNewMessages = store.getState().staff.roomsWithNewMessages;
    if (roomsWithNewMessages) {
      if (roomsWithNewMessages.length > 0) {
        notifyMeStaff('Atenção', 'Você tem mensagens não vistas no Chat Interno');
      }
    }
  }, 90000);

  io.on('novo_comentario', (data) => {
    if (!data) return null;
    const { nomeAutor, setorAutor, backoffice, filial, texto } = data.comentario

    let combineUsuarios = data.result;
    if (combineUsuarios.includes(user.id)) {

      dispatch(getListaNotificacoes(user.id))
      if (user.id !== data.comentario.autor_id) {
        const audio = document.createElement('audio');
        audio.style.display = "none";
        audio.src = chamadoSound;
        audio.autoplay = true;
        audio.onended = () => audio.remove();
        document.body.appendChild(audio);
        notifyMeComentario(`${nomeAutor}`, `\nDiz:  ${texto} \n\n Chamado: #${data.chamado.chamado}`);;
      }
      dispatch(getRefreshComments(data.chamado._id))
    }
  });

  io.on('job-count-chamados-pendentes', (data) => {

    if (!data) return null;


    if (data.direcionado_setor.includes(user.setorId) || data.direcionado_para.includes(user.id) || data.direcionado_usuarios.includes(user.id)) {
      const audio = document.createElement('audio');
      audio.style.display = "none";
      audio.src = chamadoSound;
      audio.autoplay = true;
      audio.onended = () => audio.remove();
      document.body.appendChild(audio);

      notifyMeStaff('Atenção', 'Você tem chamados pendentes');
      dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id }));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id }));
      dispatch(getListaNotificacoes(user.id))
    }

  });

  io.on('atualizar_chamados', (data) => {
    if (!data) return null;

    if (data.cliente_id) {
      if (data.cliente_id === user.clienteId) {
        dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id }));
        dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id }));
        dispatch(getListaNotificacoes(user.id))
        return;
      }
    }

    if (data.usuario_id) {
      if (data.usuario_id === user.id) {
        dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id }));
        dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id }));
        dispatch(getListaNotificacoes(user.id))
        return;
      }
    }


  });

  io.on('atualizar_tarefas', () => {
    dispatch(getListaNotificacoes(user.id));
  });

  io.on('qrcodeEvent', data => {

    const { qrcode, event } = data.data.scope;

    if (event === "qrcode") {
      dispatch(setQrcode(`data:image/png;base64,${qrcode}`))
      dispatch(setLoadingQrcodeWhatsapp(false))
      dispatch(setStatusQrcode('notLogged'))
    }

  });

  io.on('statusFindEvent', data => {
    const { event, status } = data.data.scope

    dispatch(setStatusQrcode(status))
    if (status === 'inChat') {
      window.location.href = "/chats/chat"
    }

  });

  io.on('message-in', data => {
    const { room, message } = data;
    const currentRoom = store.getState().staff.room;

    const audio = document.createElement('audio');
    audio.style.display = "none";
    audio.src = messageSound;
    audio.autoplay = true;
    audio.onended = () => audio.remove();
    document.body.appendChild(audio);

    if (!currentRoom || currentRoom._id !== room._id) {
      dispatch(setAddRoomUnread(room._id));
    }

    if (!currentRoom) {
      notifyMeStaff('Atenção', 'Você tem uma nova mensagem no Chat Interno');
    }
    if (currentRoom) {
      if (currentRoom._id === room._id) dispatch(setMessage(message));
      if (currentRoom._id !== room._id) {

        notifyMeStaff('Atenção', 'Você tem uma nova mensagem no Chat Interno');
      }
    }

    // Update Mini Chat Session Storage
    const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
    if (activeMiniChat && activeMiniChat._id === room._id) {
      const newMessages = [...(activeMiniChat.messages || []), message];
      const updatedChat = { ...activeMiniChat, messages: newMessages };
      setSessionStorageItem('chatInternoMiniId', updatedChat);
    }

    dispatch(getListaStaffsWithoutIsGroup());
    // dispatch(getListaStaffs(false))
    // dispatch(getListaStaffsGroup(true))

  });

  io.on('new-message-internal-chat', data => {
    const { room, message } = data?.data?.scope?.data;
    const currentRoom = store.getState().staff.room;

    const audio = document.createElement('audio');
    audio.style.display = "none";
    audio.src = messageSound;
    audio.autoplay = true;
    audio.onended = () => audio.remove();
    document.body.appendChild(audio);

    if (!currentRoom || currentRoom._id !== room._id) {
      dispatch(setAddRoomUnread(room._id));
    }

    if (!currentRoom) {
      notifyMeStaff('Atenção', 'Você tem uma nova mensagem no Chat Interno');

    }
    if (currentRoom) {
      if (currentRoom._id === room._id) dispatch(setMessage(message));
      if (currentRoom._id !== room._id) {

        notifyMeStaff('Atenção', 'Você tem uma nova mensagem no Chat Interno');
      }
    }

    // Update Mini Chat Session Storage
    const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
    if (activeMiniChat && activeMiniChat._id === room._id) {
      const newMessages = [...(activeMiniChat.messages || []), message];
      const updatedChat = { ...activeMiniChat, messages: newMessages };
      setSessionStorageItem('chatInternoMiniId', updatedChat);
    }

    dispatch(getListaStaffsWithoutIsGroup());
    // dispatch(getListaStaffs(false))
    // dispatch(getListaStaffsGroup(true))

  });

  io.on('job-count-chats-pendentes', data => {
    let clientesId = data.data.clientes_id;
    let setoresId = data.data.direcionado_setor;
    let usuariosId = data.data.direcionado_usuarios;
    const isMultisession = clienteParse.multiSession === 1;



    if (isMultisession) {
      let commonIds = clientesId.filter(item => clienteParse.cliente_ids.includes(item));
      let isFindCommonIds = commonIds.length > 0;

      if (isFindCommonIds) {
        if (setoresId.includes(user.setorId)) {
          dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
          if (data.sound) {
            notifyMe2();
            playSoundNotification();
          }

        } else if (usuariosId.includes(user.id)) {
          dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
          if (data.sound) {
            notifyMe2();
            playSoundNotification();
          }
        }
      }

    } else {
      if (clientesId.includes(user.clienteId)) {
        if (setoresId.includes(user.setorId)) {
          dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
          if (data.sound) {
            notifyMe2();
            playSoundNotification();
          }

        } else if (usuariosId.includes(user.id)) {
          dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
          if (data.sound) {
            notifyMe2();
            playSoundNotification();
          }
        }
      }
    }



  });


  if (clienteParse?.config?.ready_v2_webhook) {

    io.on('socket-device-refresh-list-chats', data => {
      const currentUrl = window.location.href;
      console.log("Current URL:", currentUrl);
      if (data.data.whoTo === "clienteId" && data.data.to === user.clienteId) {

        let lista = data.data.scope.lista_atualizar;
        for (const item of lista) {
          setTimeout(() => {

            if (item === "Atendendo") dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
            if (item === "Geral") dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
            if (item === "Pendente") dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, false));
            if (item === "Finalizado") dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false));
          }, 4000);
          //dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
        }
      }

      if (data.data.whoTo === "usuarioId" && data.data.to === user.id) {
        let lista = data.data.scope.lista_atualizar;
        for (const item of lista) {
          setTimeout(() => {
            if (item === "Atendendo") dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
            if (item === "Geral") dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
            if (item === "Pendente") dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, false));
            if (item === "Finalizado") dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false));
          }, 4000);
          //  dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
        }
      }
    });


    io.on('newChatToUser', data => {
      if (data.data.whoTo === "usuarioId" && data.data.scope.userIds.includes(user.id)) {

        createNotify('NOVO CHAT', 'Você tem um novo chat no seu painel')
        playSoundNotification();
      }

    });



    // recenbendo mensagens websocket front vindo do webhook
    io.on('newMessage', async data => {

      // [NOVO] Mensagens em grupo: atualiza chatsGrupos e sai cedo (não passa pelo flow 1:1)
      if (data?.data?.scope?.isGroup === true) {
        try {
          dispatch(updateChatGrupoFromSocket(data.data.scope));
        } catch (err) {
          console.log('Erro updateChatGrupoFromSocket', err?.message);
        }
        return;
      }

      const chatIdClean = data.data.scope.message.chatId.replace('@lid', '').replace('@c.us', '');
      data.data.scope.message.chatId = chatIdClean;

      if (!data || !data?.data?.scope?.message) return;
      if (data.data.scope.message.chatId === "status@broadcast") return;

      // if (clienteParse.numero + '@c.us' !== data.data.scope.message.to || clienteParse.numero + '@c.us' !== data.data.scope.message.chatId) {
      //   console.log('nao é meu numero DO CLIENTE no painel', data.data.scope?.message)
      //   return;
      // }

      const newMessage = data?.data?.scope?.message;
      const storeMsgsEnviar = getSafeState('chat.mensagensEnviar');

      // Garantir que storeMsgsEnviar seja um array válido
      const mensagensEnviar = Array.isArray(storeMsgsEnviar) ? storeMsgsEnviar : [];


      if (mensagensEnviar.length > 0 && newMessage.type === "chat") {
        console.log('Tentando remover mensagem:', newMessage.body)

        // Verificar se existe uma mensagem com o body correspondente
        const mensagemExiste = mensagensEnviar.some(item => item.body === newMessage.body);
        console.log('mensagemExiste para remover:', mensagemExiste)

        if (mensagemExiste) {
          // Filtrar a mensagem pelo body diretamente no estado
          const mensagensFiltradas = mensagensEnviar.filter((msg) => msg.body !== newMessage.body);
          dispatch(updateMensagensEnviar(mensagensFiltradas))


          console.log('mensagensFiltradas', mensagensFiltradas)
        } else {
          console.log('Mensagem não encontrada para remoção')
        }
      }

      const chatInfo = store.getState().chat.chatInfo;
      const listaChatsAtendendo = store.getState().chat.chatsAtendimento;
      const dataChatByLista = listaChatsAtendendo.find(item => item.numeroCliente === soNumeros(data.data.scope.message.chatId));

      const isMyChat = data.data.scope.usuario_id === user.id;
      const isMultisession = clienteParse.multiSession === 1;

      console.log('isMyChat', isMyChat)

      // if (!isMyChat) {
      //   return;
      // }


      if (chatInfo) {
        let listaStatus = ['Pendente', 'Geral', 'Finalizado', 'Avaliando'];
        if (listaStatus.includes(chatInfo.statusRoom)) {
          if (chatInfo.numeroCliente === soNumeros(data.data.scope.message.chatId)) {
            if (data.data.to === user.id) {
              dispatch(setMessageWhatsapp(data.data.scope.message));
            }

            dispatch(resetMensagensEnviar());
          }
        }
      }



      // verifica se é meu chat ou se usuario tem permissao root pra receber mensagens de qualquer cliente
      if (isMyChat || user.level === "root") {

        //verificando se é multi session
        if (isMultisession) {
          let listaNumerosClientesSubs = clienteParse.numeros_subs;
          if (listaNumerosClientesSubs.includes(soNumeros(data.data.scope.message.to))) {

            if (
              chatInfo?.numeroCliente + '@c.us' !== data.data.scope.message.chatId &&
              chatInfo?.numeroCliente + '@lid' !== data.data.scope.message.chatId &&
              chatIdClean !== chatInfo?.numeroCliente
            ) {

              if (!data.data.scope.message.fromMe) {

                if (data.data.scope.usuario_id === user.id) {
                  const audio = document.createElement('audio');
                  audio.style.display = "none";
                  audio.src = messageSound;
                  audio.autoplay = true;
                  audio.onended = () => audio.remove();
                  document.body.appendChild(audio);
                  notifyNewMessage(data.data.scope.message, dataChatByLista)
                }

                let dataToUpdade = {
                  _id: data.data.scope.chat_id,
                  scope: {
                    novaMensagem: 'sim',
                    dataUltimaMensagem: new Date(),
                    lastUpdate: new Date(),
                    ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                    "lastMessageWpp": {
                      "type": data.data.scope.message.type,
                      "message": checkMsgToInsert(data.data.scope.message),
                      "fromMe": data.data.scope.message.fromMe,
                      "timestamp": data.data.scope.message.t,
                      "ack": data.data.scope.message.ack,
                      "id": data.data.scope.message.id
                    }
                  }
                };
                dispatch(updateChatList(dataToUpdade));
                if (!dataChatByLista) {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                }
                setTimeout(() => {
                  dispatch(reorderChatsAtendimento())
                }, 200);

              }

            }

          }

          if (chatInfo && chatInfo?.numeroCliente) {

            if (data.data.scope.message.fromMe) {
              let cliente_id_chat = chatInfo?.cliente_id;
              let numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse.numeros_subs_data);

              if (numero_chat === soNumeros(data.data.scope.message.from)) {
                // if (Config.numero + '@c.us' === message.response.from) {
                if (
                  chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
                  chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
                  chatIdClean === chatInfo?.numeroCliente
                ) {

                  dispatch(setMessageWhatsapp(data.data.scope.message))
                  dispatch(resetMensagensEnviar());
                  if (!data.data.scope.message.fromMe) {
                    notifyNewMessage(data.data.scope.message, dataChatByLista)


                  }
                  let dataToUpdade = {
                    _id: data.data.scope.chat_id,
                    scope: {
                      dataUltimaMensagem: new Date(),
                      lastUpdate: new Date(),
                      ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                      "lastMessageWpp": {
                        "type": data.data.scope.message.type,
                        "message": checkMsgToInsert(data.data.scope.message),
                        "fromMe": data.data.scope.message.fromMe,
                        "timestamp": data.data.scope.message.t,
                        "ack": data.data.scope.message.ack,
                        "id": data.data.scope.message.id
                      }
                    }
                  };
                  dispatch(updateChatList(dataToUpdade));
                  setTimeout(() => {

                    dispatch(reorderChatsAtendimento())
                  }, 200);
                  if (!dataChatByLista) {
                    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                  }
                  // dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
                  if (["ptt", "image"].includes(data.data.scope.message.type)) {
                    setTimeout(() => {
                      downloadMediaAndSaveCache(data.data.scope.message, chatInfo, clienteParse);
                    }, 5000);
                  }


                }
              }

            } else {

              const cliente_id_chat = chatInfo?.cliente_id;
              const numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse.numeros_subs_data);
              if (numero_chat === soNumeros(data.data.scope.message.to)) {
                if (
                  chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
                  chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
                  chatIdClean === chatInfo?.numeroCliente
                ) {
                  let dataToUpdade = {
                    _id: data.data.scope.chat_id,
                    scope: {
                      novaMensagem: 'nao',
                      dataUltimaMensagem: new Date(),
                      lastUpdate: new Date(),
                      ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                      "lastMessageWpp": {
                        "type": data.data.scope.message.type,
                        "message": checkMsgToInsert(data.data.scope.message),
                        "fromMe": data.data.scope.message.fromMe,
                        "timestamp": data.data.scope.message.t,
                        "ack": data.data.scope.message.ack,
                        "id": data.data.scope.message.id
                      }
                    }
                  };

                  dispatch(updateChatList(dataToUpdade));
                  setTimeout(() => {
                    dispatch(reorderChatsAtendimento())
                  }, 200);
                  if (!dataChatByLista) {
                    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                  }
                  dispatch(setMessageWhatsapp(data.data.scope.message));

                  if (data.data.scope.message.platform === "whatsapp_business") {
                    let timestampToDate = new Date((data.data.scope.message.t * 1000));
                    if (!data.data.scope.message.fromMe) {
                      dispatch(updateChatInfoField('lastDateMsgClient', timestampToDate));
                    }
                  }


                  dispatch(addNewMessageCliente({
                    ...data.data.scope.message,
                    chatId: data.data.scope.chat_id
                  }))
                  dispatch(resetMensagensEnviar());

                }
              }
            }
          }

          // cliente nao multi session
        } else {
          // verificando se o numero do cliente painel é o mesmo do numero que chegou a mensagem
          console.log('DEBUG 1')
          // verificando se o chat nao existe e se é meu chat
          if (!chatInfo) {
            console.log('DEBUG 85485', data.data.scope.message.body)
            if (!data.data.scope.message.fromMe && data.data.scope.usuario_id === user.id) {
              const audio = document.createElement('audio');
              audio.style.display = "none";
              audio.src = messageSound;
              audio.autoplay = true;
              audio.onended = () => audio.remove();
              document.body.appendChild(audio);
              console.log('DEBUG 3 - notificando nova mensagem', data.data.scope)
              notifyNewMessage(data.data.scope.message, dataChatByLista)
            }

            let dataToUpdade = {
              _id: data.data.scope.chat_id,
              scope: {
                novaMensagem: 'sim',
                dataUltimaMensagem: new Date(),
                lastUpdate: new Date(),
                ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                "lastMessageWpp": {
                  "type": data.data.scope.message.type,
                  "message": checkMsgToInsert(data.data.scope.message),
                  "fromMe": data.data.scope.message.fromMe,
                  "timestamp": data.data.scope.message.t,
                  "ack": data.data.scope.message.ack,
                  "id": data.data.scope.message.id
                }
              }
            };
            dispatch(updateChatList(dataToUpdade));
            if (!dataChatByLista) {
              dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
            }
            setTimeout(() => {
              dispatch(reorderChatsAtendimento())
            }, 500);
            return;
          }

          // QUANDO EXISTE UM CHAT SELECIONADO
          if (chatInfo) {
            // QUANDO A MSG É DO CHAT SELECIONADO
            if (
              chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
              chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
              chatIdClean === chatInfo?.numeroCliente
            ) {

              dispatch(setMessageWhatsapp(data.data.scope.message));
              dispatch(resetMensagensEnviar());

              // Adicionar nova mensagem do cliente ao estado para mostrar botão de novas mensagens
              if (!data.data.scope.message.fromMe) {
                console.log('📨 Adicionando nova mensagem do cliente (chat selecionado):', {
                  message: data.data.scope.message,
                  chatId: data.data.scope.chat_id,
                  platform: data.data.scope.message.platform
                });
                dispatch(addNewMessageCliente({
                  ...data.data.scope.message,
                  chatId: data.data.scope.chat_id
                }));
              }

              if (data.data.scope.message.platform === "whatsapp_business") {
                let timestampToDate = new Date((data.data.scope.message.t * 1000));
                if (!data.data.scope.message.fromMe) {
                  dispatch(updateChatInfoField('lastDateMsgClient', timestampToDate));
                }
              }

              let dataToUpdade = {
                _id: data.data.scope.chat_id,
                scope: {
                  novaMensagem: 'sim',
                  dataUltimaMensagem: new Date(),
                  ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                  lastUpdate: new Date(),
                  "lastMessageWpp": {
                    "type": data.data.scope.message.type,
                    "message": checkMsgToInsert(data.data.scope.message),
                    "fromMe": data.data.scope.message.fromMe,
                    "timestamp": data.data.scope.message.t,
                    "ack": data.data.scope.message.ack,
                    "id": data.data.scope.message.id
                  }
                }
              };

              dispatch(updateChatList(dataToUpdade));
              if (!dataChatByLista) {
                dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
              }

              dispatch(updateChatList(dataToUpdade));
              setTimeout(() => {
                dispatch(reorderChatsAtendimento())
              }, 500);


              /// verificar função abaixo

              //   if (
              //     data.data.scope.message.fromMe && 
              //     clienteParse.numero + '@c.us' === data.data.scope.message.from
              //   ) {
              //         console.log('aqui 04')
              //         dispatch(setMessageWhatsapp(data.data.scope.message));
              //         let dataToUpdade = {
              //           _id: data.data.scope.chat_id,
              //           scope: {
              //             novaMensagem: 'sim',
              //             dataUltimaMensagem: new Date(),
              //             lastUpdate: new Date(),
              //             "lastMessageWpp": {
              //               "type": data.data.scope.message.type,
              //               "message": checkMsgToInsert(data.data.scope.message),
              //               "fromMe": data.data.scope.message.fromMe,
              //               "timestamp": data.data.scope.message.t,
              //               "ack": data.data.scope.message.ack,
              //               "id": data.data.scope.message.id
              //             }
              //           }
              //         };
              //         dispatch(updateChatList(dataToUpdade));
              //         setTimeout(() => {
              //           dispatch(reorderChatsAtendimento())
              //         }, 200);
              //         dispatch(resetMensagensEnviar());
              //         dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));

              // } 
              console.log('debug 59')
              return;
              // QUANDO A MSG NAO É DO CHAT SELECIONADO
            } else {
              console.log('chat selecionado, mas nao é do cliente que vei msg')
              if (chatInfo?.statusRoom === "Atendendo") {
                console.log('chat está em status Atendendo')

                if (!data.data.scope.message.fromMe && data.data.scope.usuario_id === user.id) {
                  console.log('debug 53')
                  const audio = document.createElement('audio');
                  audio.style.display = "none";
                  audio.src = messageSound;
                  audio.autoplay = true;
                  audio.onended = () => audio.remove();
                  document.body.appendChild(audio);
                  console.log('aqui 02', data.data.scope.message.body);
                  notifyNewMessage(data.data.scope.message, dataChatByLista)
                }


                let dataToUpdade = {
                  _id: data.data.scope.chat_id,
                  scope: {
                    novaMensagem: 'sim',
                    dataUltimaMensagem: new Date(),
                    lastUpdate: new Date(),
                    ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                    "lastMessageWpp": {
                      "type": data.data.scope.message.type,
                      "message": checkMsgToInsert(data.data.scope.message),
                      "fromMe": data.data.scope.message.fromMe,
                      "timestamp": data.data.scope.message.t,
                      "ack": data.data.scope.message.ack,
                      "id": data.data.scope.message.id
                    }
                  }
                };
                dispatch(updateChatList(dataToUpdade));
                if (!dataChatByLista) {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                }
                setTimeout(() => {

                  dispatch(reorderChatsAtendimento())
                }, 500);
                return;
              }
            }
            //fim do buscar atendimento
          }

        }

        ///// corggir aqui em baixo 


        let lista = data.data.scope.lista_atualizar;
        for (const item of lista) {
          if (item === "Atendendo") {
          }
          // if (item === "Atendendo" && data.data.action !== "newMessage" ) dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
          if (item === "Geral") dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
          if (item === "Pendente") dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, false));
          if (item === "Finalizado") dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false));
          //  dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
        }
      }
    });


    io.on('msgInstagramDeleted', async data => {
      const chatInfo = store.getState().chat.chatInfo;
      const instagramUserId = data.data.scope.instagramUserId;

      if (chatInfo?.instagramUser?.id === instagramUserId) {
        dispatch(getMessagesMeta(chatInfo?.sessao, instagramUserId));
      }
    });

    // recenbendo mensagens websocket front vindo do webhook
    io.on('newMessageInstagram', async data => {
      if (!data) return;

      const isFile = data.data.scope.message.message.isFile;

      const chatInfo = store.getState().chat.chatInfo;
      const listaChatsAtendendo = store.getState().chat.chatsAtendimento;
      const dataChatByLista = listaChatsAtendendo.find(item => item?.instagramUser.id === soNumeros(data.data.scope.message.chatId));
      if (data.data.scope.usuario_id === user.id) {
        const isMultisession = clienteParse.multiSession === 1;
        if (isMultisession) {
          let listaNumerosClientesSubs = clienteParse.numeros_subs;
          if (listaNumerosClientesSubs.includes(soNumeros(data.data.scope.message.to))) {

            if (chatInfo && chatInfo?.instagramUser.id !== data.data.scope.instagramUserId) {

              if (data.data.scope.message.isMe) {
                const audio = document.createElement('audio');
                audio.style.display = "none";
                audio.src = messageSound;
                audio.autoplay = true;
                audio.onended = () => audio.remove();
                document.body.appendChild(audio);
                console.log('aqui 05')
                notifyNewMessage(data.data.scope.message, dataChatByLista)
                setTimeout(() => {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
                }, 1500);
              }

            }

          }

          if (chatInfo && chatInfo?.instagramUser?.id) {

            // if (data.data.scope.message.message.isMe) {
            //   let cliente_id_chat = chatInfo.cliente_id;
            //   let numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse.numeros_subs_data);

            //   if (numero_chat === soNumeros(data.data.scope.message.from)) {

            //     // if (Config.numero + '@c.us' === message.response.from) {
            //     if (chatInfo.numeroCliente + '@c.us' === data.data.scope.message.chatId) {

            //         dispatch(setMessageWhatsapp(data.data.scope.message))
            //         dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
            //         dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
            //         // getActionAtualizarData({ chatId: chatInfo._id, lastMessage: data.data.scope.message.body }).then(() => {
            //         //   dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
            //         //   dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
            //         // })

            //     }
            //   }

            // } else {

            //   const cliente_id_chat = chatInfo.cliente_id;
            //   const numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse.numeros_subs_data);
            //   if (numero_chat === soNumeros(data.data.scope.message.to)) {
            //     if (chatInfo.numeroCliente + '@c.us' === data.data.scope.message.chatId) {
            //       if (data.data.scope.message.chatId !== "status@broadcast") {
            //         dispatch(setMessageWhatsapp(data.data.scope.message))
            //       }
            //     }
            //   }
            // }
          }

          // função para verificar se o numero base que chegou esta incluido no array de numeros do cliente

        } else {

          if (!chatInfo) {
            const audio = document.createElement('audio');
            audio.style.display = "none";
            audio.src = messageSound;
            audio.autoplay = true;
            audio.onended = () => audio.remove();
            document.body.appendChild(audio);
            notifyNewMessage("nova mensagem", dataChatByLista);
            return;
          }

          if (chatInfo && chatInfo.instagramUser?.id === data.data.scope.message.instagramUserId) {

            if (chatInfo.statusRoom === "Atendendo") {
              console.log('debug 60')
              if (!data.data.scope.message.message.fromMe) {
                const audio = document.createElement('audio');
                audio.style.display = "none";
                audio.src = messageSound;
                audio.autoplay = true;
                audio.onended = () => audio.remove();
                document.body.appendChild(audio);
                console.log('aqui 08', data.data.scope.message)
                notifyNewMessage(data.data.scope.message, dataChatByLista)
                setTimeout(() => {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
                }, 4500);

              }
            }
          }
          //fim do buscar atendimento


          if (chatInfo && chatInfo.instagramUser?.id) {

            if (data.data.scope.message.message.isMe) {
              if (chatInfo.instagramUser?.id === data.data.scope.message.instagramUserId) {// CONFERIR AQUI
                dispatch(setPushMensagemMeta(data.data.scope.message));
                dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
                dispatch(getCountsChats(user.clienteId, user.id, user.setorId));


              }

            } else {

              if (chatInfo.instagramUser?.id === data.data.scope.message.instagramUserId) {
                dispatch(setPushMensagemMeta(data.data.scope.message));
              }

            }
          }


        }

        let lista = data.data.scope.lista_atualizar;
        for (const item of lista) {
          if (item === "Atendendo") dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
          if (item === "Geral") dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
          if (item === "Pendente") dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, false));
          if (item === "Finalizado") dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false));
          //  dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
        }
      }

    });


  }


  io.on(`${user.clienteId}-meta-message`, data => {
    const currentChat = store.getState().chat.chatInfo;
    if (!currentChat) return null;

    if (data.cliente_id === user.clienteId) {
      if (data.id_usuario === currentChat.instagram_user_id) {
        dispatch(setMetaMessages(data.message))
      }

    }
  });


  io.on(`atualizar-dados-cliente`, async () => {
    const responseCliente = await getActionClienteByClienteId(user.clienteId);
    const response_clientes_canais = await actionListaClientesCanais(user.clienteId);

    let listaNumerosSubs = response_clientes_canais.data.numeros_subs;
    const numeros_subs_reduce = listaNumerosSubs.map((item) => item.nome)

    const newClienteObj = {
      ...responseCliente.data.cliente,
      clientes_canais: responseCliente.data.cliente.multiSession === 1 ? response_clientes_canais.data.data : [],
      numeros_subs: responseCliente.data.cliente.multiSession === 1 ? numeros_subs_reduce : [],
      numeros_subs_data: responseCliente.data.cliente.multiSession === 1 ? listaNumerosSubs : []
    }

    localStorage.setItem('cliente_data', JSON.stringify(newClienteObj));

    window.location.href = "/";
  });

  io.on(`atualizar-front`, () => {
    window.location.href = "/";
  });

  io.on(`force-logout`, (data) => {

    function clear() {
      // Limpar o cache de armazenamento local
      localStorage.clear();

      // Limpar o cache de sessão
      sessionStorage.clear();

      // Limpar todos os cookies
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }

      // Recarregar a página para aplicar as alterações
      window.location.reload();
    }


    if (data.data.whoTo === "clienteId" && data.data.to === user.clienteId) {
      clear()
    } else if (data.data.whoTo === "usuarioId" && data.data.to === user.id) {
      clear()
    }

  });


  const verificaIsDefcon1 = () => {
    io.on(`_defcon1`, data => {
      if (data) {
        dispatch(setDefcon1(Boolean(data.status)))
      }
    });

  }
  verificaIsDefcon1()


  io.on(`_defcon`, data => {
    if (data.tipo === "defcon1") {
      dispatch(setDefcon1(Boolean(data.status)))
    }
    if (data.tipo === "update_available") {
      dispatch(setUpdateAvailable(Boolean(data.status)))
    }
  });

  io.on(`state_whatsapp`, data => {
    console.log('data', data?.data?.scope);
    dispatch(setStateWhatsapp(data?.data?.scope));
  });

  io.on('disconnect', (reason) => {
    console.log('DESCONECTADO', reason);
  });


  io.on('private message', () => {
    console.log('DESCONECTADO')
  });

  io.on('new-analysis-chat', (data) => {
    const currentChat = store.getState().chat.chatInfo;
    if (data?.data?.scope?.analyze?.chat_id === currentChat?._id) {
      dispatch(setChatsAnalysis(data?.data?.scope?.analyze))

    }
  })


  const notifyMe2 = () => {

    // Verifica se o browser suporta notificações
    if (!("Notification" in window)) {
      alert("Este browser não suporta notificações de Desktop");
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      new Notification("CHATS PENDENTES", {
        body: `Você tem chat(s) no seu painel`
      });
    }

    else if (Notification.permission !== 'denied') {
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          new Notification("CHATS PENDENTES", {
            body: `Você tem chat(s) no seu painel`
          });
        }
      });
    }
  }


  const createNotify = (title, message) => {

    // Verifica se o browser suporta notificações
    if (!("Notification" in window)) {
      alert("Este browser não suporta notificações de Desktop");
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      new Notification(title, {
        body: message
      });
    }

    else if (Notification.permission !== 'denied') {
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          new Notification(title, {
            body: message
          });
        }
      });
    }
  }




};

export default initIO;
